

type RequestOptions = {
  method?: "GET" | "POST" | "PUT" | "DELETE";
  body?: any;
};
type ApiError = {
  status: number;
  message: string;
};
export const apiRequest = async (
  endpoint: string,
  options: RequestOptions = {}
) => {
  const { method = "GET", body } = options;
  
  const res = await fetch(`${process.env.REACT_APP_BASE_URL}${endpoint}`, {
    method,
    headers: {
      "Content-Type": "application/json",
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({})); 
  if (!res.ok) {
    const error: ApiError = {
      status: res.status,
      message: data?.message || "Something went wrong",
    };
    
    throw error;
  }
  
  return data;
};